import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ToolbarWrapper({ children }) {
    return (

        <Stack >
            <Accordion sx={{}}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="toolbar-content"
                    id="toolbar-header"
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                        Toolbar
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ maxHeight: 'max-content' }}>
                    {children}
                </AccordionDetails>
            </Accordion>
        </Stack>

    );
}


export default ToolbarWrapper;